import { render, staticRenderFns } from "./AnCheckboxes.vue?vue&type=template&id=488511c5&scoped=true&"
import script from "./AnCheckboxes.vue?vue&type=script&lang=js&"
export * from "./AnCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./AnCheckboxes.vue?vue&type=style&index=0&id=488511c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488511c5",
  null
  
)

export default component.exports